// safely accesses nested object properties
// example: get(['nested', 'array', 0], obj)

const get = (p, o) =>
	p.reduce((xs, x) => (xs && typeof xs[x] !== 'undefined') ? xs[x] : null, o)

export default get
